import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@webapp/auth/services/auth.service';
import { AppStoreService } from '../../../stores/app-store.service';
import { UserAvatarComponent } from '@webapp/ui';
import { ShowForRoleDirective } from '@webapp/core/directives/showForRole';
import { USER_ROLES } from '@webapp/users/interfaces/users.interface';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, UserAvatarComponent, ShowForRoleDirective],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  private readonly authService = inject(AuthService);
  private appState = inject(AppStoreService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);
  readonly user = this.authService.user;
  loading = signal(false);
  isDropdownOpen = false;
  isNavbarOpen = false;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const clickedInsideDropdown =
      target.closest('#user-menu-button') ||
      target.closest('.dropdown-container');

    if (!clickedInsideDropdown) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleNavbar() {
    this.isNavbarOpen = !this.isNavbarOpen;
  }

  goToProfile(){
    this.router.navigate(['/usuarios/perfil']);
  }

  getUsersButtonName(){
    return (this.user()?.role === USER_ROLES.ADMIN || this.user()?.role === USER_ROLES.SUPERADMIN) ? 'Usuarios' : 'Clientes';
  }

  async logout() {
    this.appState.set('loadingOverlay', true);
    try {
      await firstValueFrom(
        this.authService.logout().pipe(takeUntilDestroyed(this.destroyRef))
      );
      this.appState.set('loadingOverlay', false);
      this.router.navigate(['/ingresar']);
    } catch (err) {
      this.appState.set('loadingOverlay', false);
      console.error('Logout failed', err);
    }
  }
}
